import { RequirementParams } from "@/backend/access/requirement/types";
import { useRequirementsStore } from "@/frontend/store/RequirementsStore";
import { I18n } from "@/i18n/I18n";
import { useState } from "react";
import { Form } from "react-bootstrap";
import { Select } from "../Select";

export function RequirementApplicability({ requirement }: { requirement: RequirementParams }) {
  const updateRequirement = useRequirementsStore(state => state.updateRequirement);
  const [comment, setComment] = useState(requirement.comment ?? '');

  const handleApplicableChange = (applicable: boolean) => {
    void updateRequirement(requirement.id, { applicable, comment: '' });
    setComment('');
  };

  const handleCommentUpdate = async () => {
    await updateRequirement(requirement.id, { comment });
  };

  if (requirement?.applicable === undefined) {
    return null;
  }

  return (
    <div className="mt-3">
      <div className="form-label-neutral">{I18n.get('applicability')}</div>
      <div className="d-flex gap-2 mt-1">
        <Select
          label={I18n.get('applicability')}
          value={requirement.applicable ? I18n.get('applicable') : I18n.get('notApplicable')}
          neutral
        >
          {!requirement.applicable && (
            <button type="button" className="w-100 dropdown-item" onClick={() => handleApplicableChange(true)}>
              {I18n.get('applicable')}
            </button>
          )}
          {requirement.applicable && (
            <button type="button" className="w-100 dropdown-item" onClick={() => handleApplicableChange(false)}>
              {I18n.get('notApplicable')}
            </button>
          )}
        </Select>
        { !requirement.applicable &&
          <Form.Control
            className="form-control-neutral"
            type="text"
            placeholder={I18n.get('enterApplicabilityComment')}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onBlur={() => void handleCommentUpdate()}
          />
        }
      </div>
    </div>
  );
}